import { render, staticRenderFns } from "./AddResellerInvoicePage.vue?vue&type=template&id=1c860c3f"
import script from "./AddResellerInvoicePage.vue?vue&type=script&lang=js"
export * from "./AddResellerInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports